import { PEOPLE_DATA_RECEIVED, PEOPLE_DATA_UNLOADED } from './types';
import api from 'api';

export const peopleDataReceived = (data) => ({
  type: PEOPLE_DATA_RECEIVED,
  data
})

export const peopleDataUnload = () => ({
  type: PEOPLE_DATA_UNLOADED
})

export const unloadPeople = () => dispatch => {
  dispatch(peopleDataUnload())
}

// TODO: catch with user logout and user data not recived
export const getPeople = () => (dispatch) =>
    api.importantPeople.getPeople().then( people => {
    dispatch(peopleDataReceived(people))
  });
